<template>
  <div :class="classParent">
    <label v-if="label" :for="forLabel" :class="classLabel">{{ label }}</label>
    <input
      :type="typeInput"
      :class="classInput"
      :id="idInput"
      v-model="model"
      :required="required"
      :disabled="disabled"
      @change="onChange"
    />
  </div>
</template>
<script>
export default {
    props: {
        classParent: String,
        forLabel: String,
        classLabel: String,
        label: String,
        typeInput: String,
        classInput: String,
        idInput: String,
        value: String,
        required: Boolean,
        disabled: Boolean
    },
  data: function() {
    return {
      model: this.value
    };
  },
  methods: {
    onChange() {
      this.$emit("update:value", this.model);
    }
  },
};
</script>
